import React from 'react'
import { Box, Tab, Tabs, Typography } from '@mui/material'
import CarRunnerMiniGame from './CarRunnerMiniGame/CarRunnerMiniGame'
import JusteEnchereGame from './JusteEnchereGame'

const MiniGamePanel = ({ running }: { running: boolean }) => {
  const [tab, setTab] = React.useState<'auction' | 'runner'>('auction')

  const handleTabChange = (_event: React.SyntheticEvent, value: string) => {
    if (value === 'runner' || value === 'auction') {
      setTab(value)
    }
  }

  const showAuction = tab === 'auction'

  return (
    <Box
      sx={{
        mb: 2,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Tabs
        value={tab}
        onChange={handleTabChange}
        variant="fullWidth"
        sx={{ width: '100%', maxWidth: 420, mb: 2 }}
      >
        <Tab
          value="auction"
          label="La Juste Enchère"
        />
        <Tab
          value="runner"
          label="Infinite Car Runner"
        />
      </Tabs>

      {showAuction ? (
        <Box
          sx={{
            display: 'flex',
            gap: 3,
            alignItems: 'flex-start',
            justifyContent: 'center',
            width: '100%',
            flexWrap: 'wrap',
            minHeight: '52vh',
          }}
        >
          <JusteEnchereGame running={running && showAuction} />
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            gap: 3,
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            flexWrap: 'wrap',
            minHeight: '52vh',
          }}
        >
          <CarRunnerMiniGame
            running={running}
            width={480}
            height={210}
          />
        </Box>
      )}
    </Box>
  )
}

export default MiniGamePanel
